import { NgClass } from '@angular/common';
import { Component, inject, InjectionToken, input, ChangeDetectionStrategy } from '@angular/core';

import { Subject } from 'rxjs';

import { REPORT_COMPONENT_DRAG_HANDLE_CLASS } from '@core/reports-types';
import { IconComponent } from '@core/user-interface-legacy';

// TODO shared-analytics remove after migration to dashboards
export const DragHandleReadyNotifier = new InjectionToken<Subject<void>>('ReportsDragHandleReady');

@Component({
  selector: 'reports-visualization-layout',
  templateUrl: './visualization-layout.component.html',
  styleUrls: ['./visualization-layout.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IconComponent, NgClass],
})
export class VisualizationLayoutComponent {
  private readonly dragHandleNotifier = inject(DragHandleReadyNotifier, {
    optional: true,
  });
  // When this component is reused by other apps, we need to be able to target an element that is draggable
  // grid library in kiwihr requies this
  protected readonly DRAG_HANDLE_CLASS = REPORT_COMPONENT_DRAG_HANDLE_CLASS;

  public editable = input<boolean>(false);
  public displayResizeHandlers = input<boolean>();
  public filtersOverflowHidden = input<boolean>(false);

  public ngAfterViewInit() {
    if (this.dragHandleNotifier) {
      this.dragHandleNotifier.next();
    }
  }
}
